import {ParsedUrlQuery} from 'querystring';

export function getReceivedTicketInfoFromQuery({
  query,
}: {
  query: ParsedUrlQuery;
}) {
  const {ticket_uid, title, age_grade, is_helix_gift, series_id} = query;
  const ticketUid = convertQueryInputToSingleElement(ticket_uid);
  const itemTitle = convertQueryInputToSingleElement(title);
  const ageGrade = convertQueryInputToSingleElement(age_grade);
  const isHelixGift = convertQueryInputToSingleElement(is_helix_gift);
  const seriesId = convertQueryInputToSingleElement(series_id);

  return {
    ticketUid,
    title: itemTitle,
    ageGrade,
    isHelixGift,
    seriesId,
  };
}

function convertQueryInputToSingleElement(
  input: string | string[] | undefined
) {
  return Array.isArray(input) ? input[0] : input;
}
